import {useEffect} from 'react';

import {getAllProductsAllowedByCnae} from '../services/Api';
import {useEcStore} from '../store/slices/ecStore';
import {useInteractionStore} from '../store/slices/interactionStore';

export const useGetProductsCnae = () => {
  const primaryCnae = useEcStore((state) => state.ec.ecBasicData.primaryCnae);
  const productsCnae = useInteractionStore((state) => state.productsCnae);
  const productsDiscoveryCnae = useInteractionStore(
    (state) => state.productsDiscoveryCnae
  );

  useEffect(() => {
    if (!productsCnae.length && primaryCnae) {
      getAllProductsAllowedByCnae(primaryCnae)
        .then((response) => {
          productsDiscoveryCnae(response.data);
        })
        .catch((error) => {
          console.error('[useGetProductsCnae] API Error:', error);
        });
    }
  }, [primaryCnae, productsCnae, productsDiscoveryCnae]);
};
